// extracted by mini-css-extract-plugin
export default {"dotContainer":"Dots_dotContainer__N3q6H","dots":"Dots_dots__8ZPyJ","dot":"Dots_dot__1ilmc"};